<template>
  <div class="formData">
    <el-form :model="sForm" ref="sForm" label-width="100px" class="all-form" size="small" style="padding-right: 0">
      <el-form-item :prop="item.fieldName" :rules="item.isRequired==1 ? rulesFunc(item):[{required: false}]" 
        class="mb15" v-for="(item,index) in formColumnList.filter(item => { 
          if (orderEdit) {
            return item.fieldName!='labelPath' && item.fieldName!='cId'
          } else {
            return item.fieldName!='labelPath'
          }
        })" :key="index" :style="getStyle(item)">
        <span slot="label">{{item.fieldCnName}}</span>
        <!-- 日期时间范围选择 -->
        <el-date-picker v-if="item.inputType === 'datetimerange'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="datetimerangeObj[item.fieldName]" type="datetimerange" range-separator="~" @change="sForm[item.fieldName]=datetimerangeObj[item.fieldName]?datetimerangeObj[item.fieldName][0]:''"
          :start-placeholder="Language('开始日期')" :end-placeholder="Language('结束日期')" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <!-- date -->
        <el-date-picker v-else-if="item.inputType == 'date'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="sForm[item.fieldName]" type="date" :placeholder="Language('请选择')+item.fieldCnName"></el-date-picker>
        <!-- time -->
        <el-date-picker v-else-if="item.inputType == 'time'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="sForm[item.fieldName]" type="time" :placeholder="Language('请选择')+item.fieldCnName"></el-date-picker>
        <!-- datetime -->
        <el-date-picker v-else-if="item.inputType == 'datetime'" :disabled="editType=='examine'||editType=='info'||editType=='return'"
          style="width:100%;" v-model="sForm[item.fieldName]" type="datetime" :placeholder="Language('请选择')+item.fieldCnName"></el-date-picker>
        <!-- 开关 -->
        <el-switch v-else-if="item.fieldName === 'isOverTime' || item.fieldName === 'isWheelOverTime' || item.fieldName === 'isTipsCus' 
          || item.fieldName === 'isVisit' || item.fieldName === 'isBeVisit' || item.fieldName === 'isSolved' || item.fieldName === 'isSat'"
          v-model="sForm[item.fieldName]" :active-value="'1'" :inactive-value="'0'" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-switch>
        <!-- 单选框、多选框 -->
        <RadioCheckBox v-else-if="item.inputType=='radio'||item.inputType=='checkbox'" :ref="item.fieldName" :dataOrigin="item.dataOrigin"
          :inputType="item.inputType" :fieldName="item.fieldName" :editType="editType" :filterData="filterData[item.dataOrigin]"></RadioCheckBox>
        <!-- 选择框 -->
        <SelectList style="width:100%;" v-else-if="item.inputType==='select'||item.inputType =='personnelSelect'"
        :placeholderLoad="item.fieldCnName" :dataMultiple="item.selectType" :ref="item.fieldName" :dataOrigin="item.dataOrigin"
        :inputType="item.inputType" :fieldName="item.fieldName" :editType="editType" @selectChange="selectChange" @changeOrgFn="changeOrgFn"
        :filterData="filterData[item.dataOrigin]"></SelectList>
        <!-- 级联选择 -->
        <CascaderList style="width:100%;" :checkStrictly="item.cascadeType==1?true:false" v-else-if="item.inputType === 'cascader'"
        :placeholderLoad="item.fieldCnName" :ref="item.fieldName" :dataOrigin="item.dataOrigin" :editType="editType"></CascaderList>
        <!-- 多行文本 -->
        <el-input style="width:100%" v-else-if="item.inputType === 'textarea'" type="textarea" v-model.trim="sForm[item.fieldName]" 
          :placeholder="Language('请输入')+item.fieldCnName" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-input>
        <!-- 数字框 -->
        <el-input-number v-model="sForm[item.fieldName]" style="width:150px" v-else-if="item.inputType === 'number'" 
          controls-position="right" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-input-number>
        <!-- 人员部门选择框 -->
        <DepartPersonSelect v-else-if="item.inputType === 'departmentSelect'" :ref="item.fieldName" :editType="editType"></DepartPersonSelect>
        <!-- 客户标签 -->
        <div v-else-if="item.fieldName == 'labelData'">
          <div class="label-list" v-if="cusLabPath&&cusLabPath.length" :ref="item.fieldName">
            <!-- <span class="labelItem" v-for="(item, index) in cusLabPath" :key="index">{{item.LabPath}}<i @click="removeCusLab(item, index)" v-if="editType!='examine'&&editType!='info'&&editType!='return'">x</i></span> -->
            <span v-if="editType!='examine'&&editType!='info'&&editType!='return'">
              <el-tag style="margin-right:5px;" type="success" size="small" v-for="(item, index) in cusLabPath" :key="index" closable @close="removeCusLab(item, index)">{{item.LabPath}}</el-tag>
            </span>
          </div>
          <el-button type="text" @click="cusLabVisible=true" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{cusLabPath.length?'继续选择':'选择标签'}}</el-button>
        </div>
        <!-- 联系电话 -->
        <div v-else-if="item.fieldName=='telData'">
          <el-input v-if="GLOBAL.power.is_1030||GLOBAL.power.is_1031" v-model.trim="sForm[item.fieldName+'-re']" clearable :placeholder="Language('请输入')+item.fieldCnName" disabled class="input-with-select addData" :style="{width: orderEdit?'calc(100% - 55px)':'100%'}">
            <el-button slot="append" icon="iconfont icon-ai57-btn" @click="handleAddFn(item.fieldName)" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{Language('添加')}}</el-button>
          </el-input>
          <el-input v-else v-model.trim="sForm[item.fieldName]" clearable :placeholder="Language('请输入')+item.fieldCnName" disabled class="input-with-select addData" :style="{width: orderEdit?'calc(100% - 55px)':'100%'}">
            <el-button slot="append" icon="iconfont icon-ai57-btn" @click="handleAddFn(item.fieldName)" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{Language('添加')}}</el-button>
          </el-input>
          <i class="iconfont iconhuifang font-16 cur-p blue ml-5" v-if="item.fieldName=='telData'&&orderEdit" @click="handleMsgFn(item.fieldName, 1)"></i>
          <i class="iconfont icona-008duanxin font-20 cur-p blue" v-if="item.fieldName=='telData'&&orderEdit" @click="handleMsgFn(item.fieldName, 2)"></i>
        </div>
        <!-- 联系邮箱 -->
        <div v-else-if="item.fieldName=='emailData'">
          <el-input v-model.trim="sForm[item.fieldName]" clearable :placeholder="Language('请输入')+item.fieldCnName" disabled class="input-with-select addData" :style="{width: orderEdit?'calc(100% - 55px)':'100%'}">
            <el-button slot="append" icon="iconfont icon-ai57-btn" @click="handleAddFn(item.fieldName)" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{Language('添加')}}</el-button>
          </el-input>
          <i class="iconfont icona-009youjian font-20 cur-p blue ml-5" v-if="item.fieldName=='emailData'&&orderEdit" @click="handleMsgFn(item.fieldName, 3)"></i>
        </div>
        <!-- 输入框 -->
        <div style="position: relative;" v-else>
          <el-dropdown class="hotlineCusname" @command="handleCommand">
            <span class="el-dropdown-link">
              <i v-if="(item.fieldName=='cusName'&&editType=='hotline'&&hotlineCusList.length)" slot="reference" class="el-icon-s-custom el-input__icon font-22 cur-p blue" title="选择客户"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-user-solid" v-for="(item, index) in hotlineCusList" :key="index" :command="item">{{item.cusName}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-input v-model.trim="sForm[item.fieldName]" :placeholder="Language('请输入')+item.fieldCnName" :clearable="editType!='hotline'" :disabled="editType=='examine'||editType=='info'||editType=='return'" class="input-with-select" style="width:100%">
            <el-button v-if="((item.fieldName=='cusName'||item.fieldName=='name')&&orderEdit)" slot="append" icon="el-icon-search" @click="openCusSelectFn(item.fieldName)" :disabled="editType=='examine'||editType=='info'||editType=='return'"></el-button>
          </el-input>
        </div>
      </el-form-item>
      <el-row class="submitButton" v-if="showSubButton">
        <el-form-item>
          <el-button type="primary" @click="saveFn" :disabled="editType=='examine'||editType=='info'||editType=='return'">{{Language('提 交')}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <!-- 添加电话、邮箱 -->
    <el-dialog custom-class="addOperator center-dialog Operator-add new-dialog-box" :title="operateTitle" width="25%" 
      :visible.sync="detDialog" :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false">
      <div class="detInfoList">
        <el-form :model="detForm" ref="detForm" class="padding10-15">
          <el-table :data="detForm.dataList" style="padding:0;">
            <el-table-column prop="data" :label="Language('电话')" v-if="detType=='telData'">
              <template slot-scope="scope" v-if="detType=='telData'">
                <el-form-item prop="datare" :rules="rulesFunc2(scope.row)" v-if="GLOBAL.power.is_1031">
                  <el-input v-model.trim="scope.row.datare" style="width:220px;" :disabled="isCallout"></el-input>
                </el-form-item>
                <el-form-item prop="data" :rules="rulesFunc2(scope.row)" v-else>
                  <el-input v-model.trim="scope.row.data" style="width:220px;" :disabled="isCallout"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="data" :label="Language('邮箱')" v-if="detType=='emailData'">
              <template slot-scope="scope">
                <el-form-item prop="data" :rules="rulesFunc2(scope.row)">
                  <el-input v-model.trim="scope.row.data" style="width:220px;" :disabled="isCallout"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="Language('操作')" width="100">
              <template slot-scope="scope">
                <el-tooltip placement="top" :enterable="false">
                  <div slot="content">{{Language(!isCallout?'删除':'外呼')}}</div>
                  <i v-if="!isCallout" class="iconfont icon-shanchu table-icon-btn" style="color: red;" @click="delEntityItemFn(scope.$index, scope.row)"></i>
                  <i v-else class="iconfont iconhuifang font-16 cur-p blue ml-5" @click="handleCalloutFn(scope.row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-button v-if="!isCallout" type="text" icon="el-icon-plus" style="margin-left: 10px;" @click="addEntityItemFn">{{operateTitle}}</el-button>
        </el-form>
      </div>
      <div class="diglog-bom-box" v-if="!isCallout">
        <el-button type="primary" size="small" @click="handleSubmitFn" :disabled="!isPassRules">{{Language('确定')}}</el-button>
        <el-button size="small" @click="detDialog=false">{{Language('取消')}}</el-button>
      </div>
    </el-dialog>

    <!-- 选择客户 -->
    <el-dialog custom-class="addOperator center-dialog Operator-add new-dialog-box" :title="Language('客户')" width="60%" 
      :visible.sync="customerDialog" :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false">
      <div class="searchForm">
        <el-form :model="searchForm" :inline="true">
          <el-form-item :label="Language('客户名称')" prop="cusName">
            <el-input v-model.trim="searchForm.cusName" clearable maxlength="20" style="width:220px;" :placeholder="Language('客户名称')" @keyup.enter.native="customerGetListFn(1)"></el-input>
          </el-form-item>
          <el-form-item :label="Language('联系方式')">
            <el-select v-model="searchForm.contactType" style="width:120px;" :placeholder="Language('渠道类型')" clearable>
              <el-option v-for="item in filterData['orderOriginType']" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
            </el-select>
            <el-input v-model.trim="searchForm.contactVal" clearable style="width:220px;" :placeholder="Language('联系方式')" @keyup.enter.native="customerGetListFn(1)"></el-input>
          </el-form-item>
          <el-form-item label-width="15px">
            <el-button type="primary" size="mini" @click="customerGetListFn(1)" class="queryBtn">{{ Language('查询') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="cusList">
          <el-table-column prop="cusName" :label="Language('客户名称')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="sex" :label="Language('客户性别')" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ Language(scope.row.sex == 1 ? '男' : '女') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="telData" :label="Language('客户电话')" show-overflow-tooltip :formatter="formatterPhone2" v-if="!GLOBAL.power.is_1030"></el-table-column>
          <el-table-column prop="emailData" :label="Language('客户邮箱')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" :label="Language('客户描述')" show-overflow-tooltip></el-table-column>
          <el-table-column :label="Language('操作')" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click.native="handleSelectCus(scope.row, 1)" style="padding: 0;">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pageSize" :total="total" v-if="total>0"></el-pagination>
      </div>
    </el-dialog>

    <!-- 选择公司 -->
    <el-dialog custom-class="addOperator center-dialog Operator-add new-dialog-box" :title="Language('公司')" width="60%" 
      :visible.sync="cusCompanyDialog" :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false">
      <div class="searchForm">
        <el-form :model="searchForm" :inline="true">
          <el-form-item :label="Language('公司名称')" prop="name">
            <el-input v-model.trim="searchForm.name" clearable maxlength="20" style="width:220px;" @keyup.enter.native="cusCompanyGetListFn(1)"></el-input>
          </el-form-item>
          <el-form-item label-width="15px">
            <el-button type="primary" size="mini" @click="cusCompanyGetListFn(1)" class="queryBtn">{{ Language('查询') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="cusCompanyList">
          <el-table-column prop="name" :label="Language('公司名称')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" :label="Language('公司描述')" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createOper" :label="Language('创建人')">
            <template slot-scope="scope">
              <span>{{formatColumn('createOper', scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="Language('操作')" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click.native="handleSelectCus(scope.row, 2)" style="padding: 0;">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pageSize" :total="total" v-if="total>0"></el-pagination>
      </div>
    </el-dialog>

    <!-- 客户标签 -->
    <el-dialog class="cusLabDialog" :title="Language('客户标签')" width="60%" :visible.sync="cusLabVisible" :close-on-press-escape="false" :close-on-click-modal="false" 
      :modal-append-to-body="false">
      <CusLable @submitLabFn="submitLabFn" v-if="cusLabVisible" :cusLabPath="cusLabPath"></CusLable>
    </el-dialog>
  </div>
</template>

<script>
  import { customerGetList, customerGetInfo } from "@/http/customerManagement.js"
  import { cusCompanyGetList, cusCompanyGetInfo } from "@/http/cusCompanyManagement.js"
	import { getDictMap } from '@/http/BaseData.js'
	import SelectList from './SelectList.vue'
	import RadioCheckBox from './RadioCheckBox.vue'
	import CascaderList from './CascaderList.vue'
	import DepartPersonSelect from './DepartPersonSelect.vue'
	import AreaSelect from './AreaSelect.vue'
  import CusLable from './CusLable.vue'
  import { formatTableData } from '@/utils/auth'

  export default {
    name: "customerManagement",
    props: { 
      hotlineObj: Object,
      formColumnList: Array,
      dialogShow: Boolean,
      editType: String, //修改类型 info：查看 add：新增 edit：编辑 examine：审批 supervise：督办 hotline：弹屏
      showSubButton: { 
        type: Boolean, default: function() {
          return false
        }, required: false
      },
      orderEdit: { //是否工单里面编辑信息
        type: Boolean, default: function() {
          return false
        }, required: false
      },
      sFormInfo: { 
        type: Object, default: function() {
          return {}
        }, required: false
      },
      formId: { 
        type: String, default: function() {
          return ''
        }, required: false
      }
    },
    components: { SelectList, CascaderList, DepartPersonSelect, AreaSelect, RadioCheckBox, CusLable },
    data() {
      return {
        vdnId: '',
        datetimerangeObj: [],
        sForm: {},
        orderInfo: {}, //工单信息
        labelSelected: [], //已选择的客户标签
        hotlineCusList: [],
        selectedCus: '',
        detDialog: false, //添加电话、邮箱弹窗
        customerDialog: false, //选择客户弹窗
        cusCompanyDialog: false, //选择公司弹窗
        operateTitle: '',
        searchCusName: '',
        detType: '',
        cusList: [], //客户列表数据
        cusCompanyList: [], //公司列表数据
        total: 0,
        pageSize: 10,
        pageNo: 1,
        isPassRules: true,
        isCallout: false, //拨号
        filterData: [], //下拉数据集
        cusLabVisible: false, //客户标签-弹窗
        cusLabPath: [],
        labelList: [],
        labelIds: [],
        searchForm: {},
        detForm: {
          dataList: [],
        },
      }
    },
    watch:{
      dialogShow: {
        deep: true,
        handler: function (newV, oldV) {
          this.handleClose()
        },
      },
      sFormInfo: {
        deep: true,
        handler: function (newV, oldV) {
          if (JSON.stringify(newV)!="{}") this.setFormData(newV)
          else this.setFormNull()
        },
      },
      formColumnList: {
        deep: true,
        handler: function (newV, oldV) {
          const self = this
          setTimeout(function() { 
            if (self.editType == 'hotline') {
              if (self.hotlineObj) self.customerGetListFn(1, 'hotline')
            } 
            // else self.setFormData(self.orderInfo) 
          }, 500)
        },
      },
    },
    mounted() {
      this.vdnId = JSON.parse(LocalStorage.getItem("obj")).vdnId
      this.getDictyFilterData()
    },
    created() {},
    methods: {
      formatter(val){
        if(this.GLOBAL.power.is_1031){
          //号码隐藏
          val = this.hidePhoneNum(val)
        }
        return val
      },
      formatColumn(name, row) {
        return formatTableData(name, row)
      },
      //切换部门
      changeOrgFn(data) {
        if (this.$refs['userId']) {
          this.$refs['userId'][0].fetchUserListFn(data)
        }
      },
      //移除客户标签
      removeCusLab(item, index) {
        this.cusLabPath.splice(index, 1)
      },
      //选择客户标签点击确定、取消
      submitLabFn(type, val, ids) { //type=1:确定2：取消 val:结果集(路径) ids:id数组
        if (type==1) {
          this.labelList = val
          this.labelIds = ids
          let list = this.labelList.split(';')
          this.cusLabPath = []
          if (list && list.length) {
            list.map((item, i) => {
              if (item) this.cusLabPath.push({ LabPath: item, Id: this.labelIds[i] })
            })
          }
        }
        this.cusLabVisible = false
      },
      //统一获取下拉框数据
      getDictyFilterData(){
        let paramsSelectData = this.formColumnList.filter(item=>{
          if( item.dataOrigin && item.dataOrigin!='0' ) return item
        })
        let selectParams =  paramsSelectData.map(item=>{ return item.dataOrigin })
        selectParams.push('sex')
        selectParams.push('orderOriginType')
        let selectParamsony = Array.from(new Set(selectParams))//去重
        if (selectParamsony.length) {
          let params = {
            dictTypeCodeList: selectParamsony,
            vdnId: this.vdnId
          }
          getDictMap(params).then((res)=>{ 
            if(res && res.retCode == 1){
              this.filterData = res.data
            }
          })
        }
      },
      selectChange(data, fieldName) {
        if (fieldName=='cId'&&this.orderEdit) {
          this.$parent.getCusCompanyInfo(data)
        }
      },
      //打开客户、公司搜索
      openCusSelectFn(val) {
        this.pageSize = 10
        this.pageNo = 1
        if (val == 'cusName') {
          this.searchForm = {}
          this.customerDialog = true
          this.customerGetListFn()
        } else if (val == 'name') {
          this.searchForm = {}
          this.cusCompanyDialog = true
          this.cusCompanyGetListFn()
        }
      },
      handleCommand(data) {
        this.handleSelectCus(data, 1)
      },
      //确定选择的客户、公司  type: 1客户  2公司
      handleSelectCus(row, type) {
        if (type == 1) this.fetchCustomerInfo(row.id)
        if (type == 2) this.fetchCusCompanyInfo(row.id)
      },
      //获取客户信息
      fetchCustomerInfo(id) {
        customerGetInfo({
          vdnId: this.vdnId,
          id: id
        }).then(res => {
          if (res && res.retCode == 1) {
            this.$emit('changeCusInfo', res.data)
            this.customerDialog = false
            this.$nextTick(()=>{
              this.$refs.sForm.clearValidate()
            })
          }
        })
      },
      //获取客户公司信息
      fetchCusCompanyInfo(id) {
        cusCompanyGetInfo({
          vdnId: this.vdnId,
          id: id
        }).then(res => {
          if (res && res.retCode == 1) {
            this.$emit('changeCusCompanyInfo', res.data)
            this.cusCompanyDialog = false
            this.$nextTick(()=>{
              this.$refs.sForm.clearValidate()
            })
          }
        })
      },
      handleCurrentChange(currentPage) {
        this.pageNo = currentPage
        if (this.customerDialog) this.customerGetListFn()
        if (this.cusCompanyDialog) this.cusCompanyGetListFn()
      },
      handleSizeChange(pageSize) {
        this.pageSize = pageSize
        if (this.customerDialog) this.customerGetListFn()
        if (this.cusCompanyDialog) this.cusCompanyGetListFn()
      },
      //客户列表
      customerGetListFn(pageNo, type) {
        // queryData
        let queryData = []
        if (this.searchForm['cusName']) queryData.push({ fieldName: 'cusName', value: this.searchForm['cusName'] })
        if (this.searchForm['contactType']) queryData.push({ fieldName: 'contactType', value: this.searchForm['contactType'] })
        if (this.searchForm['contactVal']) queryData.push({ fieldName: 'contactVal', value: this.searchForm['contactVal'] })
        if (!this.searchForm['cusName'] && !this.searchForm['contactType'] && !this.searchForm['contactVal']) queryData = []
        //showData
        let showData = [
          { fieldName: 'cusName' },
          { fieldName: 'sex' },
          { fieldName: 'telData' },
          { fieldName: 'emailData' },
          { fieldName: 'remark' }
        ]
        //请求查询接口
        let params = {
          vdnId: this.vdnId,
          pageSize: this.pageSize,
          pageNo: pageNo?pageNo:this.pageNo,
          queryData: queryData,
          showData: showData
        }
        //弹屏-查询用户
        if (type == 'hotline') {
          params = {
            vdnId: this.vdnId,
            pageSize: 999,
            pageNo: 1,
            queryData: [],
            showData: [
              { fieldName: 'cusName' },
              { fieldName: 'sex' },
              { fieldName: 'telData' },
              { fieldName: 'emailData' },
              { fieldName: 'remark' }
            ]
          }
          this.$nextTick(function() {
            params.queryData = [
              { fieldName: 'contactType', value: this.hotlineObj['originType'] },
              { fieldName: 'contactVal', value: this.hotlineObj['vId'] },
            ]
          })
        }
        customerGetList(params).then((res) => {
          if (res && res.retCode === 1) {
            if (type == 'hotline') {
              this.hotlineCusList = res.data.list
              if (this.hotlineCusList.length) this.handleSelectCus(this.hotlineCusList[0], 1)
            } else {
              this.cusList = res.data.list
              this.total = res.data.total
            }
          }
        })
      },
      //客户公司列表
      cusCompanyGetListFn(pageNo) {
        // queryData
        let queryData = []
        if (this.searchForm['name']) queryData.push({ fieldName: 'name', value: this.searchForm['name'] })
        if (this.searchForm['createOper']) queryData.push({ fieldName: 'createOper', value: this.searchForm['createOper'] })
        if (!this.searchForm['name'] && !this.searchForm['createOper']) queryData = []
        //showData
        let showData = [
          { fieldName: 'name' },
          { fieldName: 'remark' },
          { fieldName: 'createOper' },
        ]
        //请求查询接口
        let params = {
          vdnId: this.vdnId,
          pageSize: this.pageSize,
          pageNo: pageNo?pageNo:this.pageNo,
          queryData: queryData,
          showData: showData
        }
        cusCompanyGetList(params).then(res => {
          if (res && res.retCode === 1) {
            this.cusCompanyList = res.data.list
            this.total = res.data.total
          }
        })
      },
      //确认电话、邮箱数据提交
      handleSubmitFn() {
        let dataList = this.detForm['dataList'], array = [], returnStr = ''
        if (this.detType == 'telData') {
          if (this.GLOBAL.power.is_1031) {
            if (dataList.length) {
              let array1 = [], array2 = []
              dataList.map(item => { 
                if (item.data && item.datare) {
                  if (item.datare.indexOf('*')>-1) {
                    array1.push(item.data)
                    array2.push(item.data)
                  } else {
                    array1.push(item.datare)
                    array2.push(item.datare)
                  }
                } else if (!item.data&&item.datare) {
                  array1.push(item.datare)
                  array2.push(item.datare)
                }
              })
              this.$set(this.sForm, 'telData', array1.join(','))
              this.$set(this.sForm, 'telData-re', this.formatterPhone(array2.join(',')))
            } else {
              this.$set(this.sForm, 'telData', '')
              this.$set(this.sForm, 'telData-re', '')
            }
          } else {
            if (dataList.length) {
              dataList.map(item => { if (item.data) array.push(item.data) })
              returnStr = array.join(',')
              this.$set(this.sForm, this.detType, returnStr)
            } else this.$set(this.sForm, this.detType, '')
          }
        } else {
          if (dataList.length) {
            dataList.map(item => { if (item.data) array.push(item.data) })
            returnStr = array.join(',')
            this.$set(this.sForm, this.detType, returnStr)
          } else this.$set(this.sForm, this.detType, '')
        }
        this.detDialog = false
      },
      //type: 1拨打电话、2发送信息、3发送邮件
      handleMsgFn(fieldName, type) {
        if (this.sForm[fieldName]) {
          let data = this.sForm[fieldName]
          if (type == 1) {
            if (data.split(',').length>1) {
              this.handleAddFn(fieldName)
              this.isCallout = true
              this.operateTitle = '拨打电话'
            } else top.postMessage({ message: "callout", phone: data }, "*")
          }
          else if (type == 2) top.postMessage({message: 'sendsms', phone: data }, '*')
          else top.postMessage({message: 'sendemail', email: data }, '*')
        }
      },
      handleCalloutFn(item) {
        top.postMessage({ message: "callout", phone: item.data }, "*")
        this.detDialog = false
        setTimeout(function() { this.isCallout = false })
      },
      //添加电话、邮箱
      handleAddFn(fieldName) {
        let data = this.sForm[fieldName], datare = this.sForm[fieldName+'-re']
        this.detType = fieldName
        this.detDialog = true
        this.isCallout = false
        this.detForm.dataList = []
        this.operateTitle = fieldName == 'telData'?'添加电话':'添加邮箱'
        if (data) {
          if (fieldName == 'telData') {
            if (this.GLOBAL.power.is_1031) {
              datare.split(',').map((item, index) => {
                this.detForm.dataList.push({ data: data.split(',')[index], datare: item })
              })
            } else {
              data.split(',').map(item => {
                this.detForm.dataList.push({ data: item })
              })
            }
          } else {
            data.split(',').map(item => {
              this.detForm.dataList.push({ data: item })
            })
          }
        }
        this.$nextTick(function() {
          this.$refs['detForm'].clearValidate()
        })
      },
      //添加电话、邮箱-删除
      delEntityItemFn(index, row) {
        this.detForm.dataList.splice(index, 1)
        this.isPassRules = true
      },
      //新增电话、邮箱item
      addEntityItemFn() {
        if (this.detType == 'telData') this.detForm.dataList.push({ data: '', datare: '' })
        else this.detForm.dataList.push({ data: '' })
      },
      //模板选择点击事件
      handleNodeClick(data, node, obj, fieldName) {
        this.$refs[fieldName][0].doClose()
        this.$set(this.sForm, fieldName, data['content'])
      },
      getStyle(item) {
        let style = 'width: 100%;display: block;'
        style += 'vertical-align: top;'
        return style
      },
      rulesFunc(item){
        if(item.inputType =="select"||item.inputType =="radio"){
          let validateSelect= (rule, value, callback) => {
            if (!this.$refs[item.fieldName][0].values) {
              return callback(new Error(this.Language('必填')))
            } else {
              callback()
            }
          }
          return [{ required: true, validator: validateSelect, trigger:'change'}]
        }else{
          return [{ required: true, message: `请填入${item.fieldCnName}`}]
        }
      },
      rulesFunc2(item){
        let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/; // /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g
        let regPhone = window._CONFIG.phoneReg;
        if (item.data||item.datare) {
          if (this.detType == 'emailData' && !regEmail.test(item.data)) {
            this.isPassRules = false
            return [
              { required: true, message: this.Language("请输入正确邮箱"), trigger: "blur" }
            ]
          } else if (this.detType == 'telData' && this.GLOBAL.power.is_1031 && !regPhone.test(item.datare)) {
            this.isPassRules = false
            return [
              { required: true, message: this.Language("请输入正确手机号码/电话号码"), trigger: "blur" }
            ]
          } else if (this.detType == 'telData' && !this.GLOBAL.power.is_1031 && !regPhone.test(item.data)) {
            this.isPassRules = false
            return [
              { required: true, message: this.Language("请输入正确手机号码/电话号码"), trigger: "blur" }
            ]
          } else {
            this.isPassRules = true
            return [{ required: false }]
          }
        } else {
          this.isPassRules = true
          return [{ required: false }]
        }
      },
      //列表格式化电话
      formatterPhone2(row, column ,val){
        let phones = val?val.split(','):[], newPhones = [], returnStr = ''
        if (this.GLOBAL.power.is_1031) {//号码替换
          phones.map(item => {
            newPhones.push(this.hidePhoneNum(item))
          })
          returnStr = newPhones.join(',')
        } else returnStr = val
        return returnStr
      },
      //格式化电话
      formatterPhone(val){
        let phones = val?val.split(','):[], newPhones = [], returnStr = ''
        if (this.GLOBAL.power.is_1030) {//号码隐藏All
          phones.map(item => {
            newPhones.push(this.hidePhoneNumAll(item))
          })
          returnStr = newPhones.join(',')
        } else if (this.GLOBAL.power.is_1031) {//号码替换
          phones.map(item => {
            newPhones.push(this.hidePhoneNum(item))
          })
          returnStr = newPhones.join(',')
        } else returnStr = val
        return returnStr
      },
      setFormData(data) {
        this.formColumnList.forEach(row => {
          if (row.inputType === 'cascader') {
            if (data[row.fieldName]) this.$refs[row.fieldName][0].$refs['toclearRef'].values = data[row.fieldName].split(',')
          } else if(row.inputType === 'select'){
            if (row.fieldName == 'cId' && this.orderEdit) {
              this.$set(this.sForm, 'cId', data[row.fieldName])
            } else {
              if (row.selectType==2&&data[row.fieldName]) this.$refs[row.fieldName][0].values = data[row.fieldName].split(',')
              else this.$refs[row.fieldName][0].values = data[row.fieldName]
            }
          } else if(row.inputType === 'radio'){
            this.$refs[row.fieldName][0].values = data[row.fieldName]
          } else if (row.inputType == 'checkbox') {
            this.$refs[row.fieldName][0].values2 = JSON.parse(data[row.fieldName])
          } else if (row.inputType === 'datetimerange') {
            this.$set(this.sForm, row.fieldName, data[row.fieldName])
          } else if (row.fieldName == 'labelData') {
            if (data['labelData']&&data['labelPath']) {
              this.cusLabPath = []
              let labelData = data['labelData'].split(',')
              let labelPath = data['labelPath'].split(',')
              if (labelData.length) {
                labelData.map((item, index) => {
                  this.cusLabPath.push({ LabPath: labelPath[index], Id: item })
                })
              }
            }
          } else if (row.fieldName=='telData') {
            this.$set(this.sForm, row.fieldName+'-re', this.formatterPhone(data[row.fieldName]))
            this.$set(this.sForm, row.fieldName, data[row.fieldName])
          } else {
            this.$set(this.sForm, row.fieldName, data[row.fieldName])
          }
				})
        this.$set(this.sForm, 'id', data['id'])
      },
      setFormNull() {
        this.formColumnList.forEach(row => {
          this.$set(this.sForm, row.fieldName, '')
        })
        this.$set(this.sForm, 'id', '')
      },
      //重置表单
      handleClose() {
        this.sForm = {}
        this.resetFn()
        this.$nextTick(()=>{
          this.$refs.sForm.clearValidate()
        })
      },
			resetFn(){
				this.datetimerangeObj = []
				for (let fild in this.sForm) {
					this.sForm[fild] = null
				}
				this.formColumnList.forEach(row => {
          if(row.inputType === 'select' || row.inputType === 'cascader'){
            this.$refs[row.fieldName][0].values = ''
          }
				})
			},
      saveFn() {
        const self = this
        this.$refs.sForm.validate((valid) => {
          if (valid) {
            var refs = this.$refs
            for (let fild in refs) {
              if (fild == 'groupId') {
                let values = this.$refs[fild][0].values, newValues = []
                if (typeof(values) == 'string') newValues = values.split(',')
                else newValues = values
                if (newValues.length) this.sForm[fild] = newValues[newValues.length-1]
                else this.sForm[fild] = ''
              } else if (fild == 'labelData') {
                if (this.cusLabPath.length) {
                  let cusLabId = [], cusLabPath = []
                  this.cusLabPath.map(item => {
                    cusLabId.push(item.Id)
                    cusLabPath.push(item.LabPath)
                    this.sForm['labelData'] = cusLabId.join(',')
                    this.sForm['labelPath'] = cusLabPath.join(',')
                  })
                }
              } else if (fild != 'sForm' && fild != 'content' && fild != 'handleContent' && fild != 'detForm') {
                let value = this.$refs[fild][0].values || this.$refs[fild][0].value
                if (value instanceof Array || value instanceof Array) {
                  if (value.length) this.sForm[fild] = value.join(',')
                  else this.sForm[fild] = ''
                } else this.sForm[fild] = value || ''
              }
            }
            this.formColumnList.forEach(row => {
              if (this.datetimerangeObj[row.fieldName] !=null && this.datetimerangeObj[row.fieldName] !='' && this.datetimerangeObj[row.fieldName] != undefined){
                this.sForm[`${row.fieldName}_begin`] = this.datetimerangeObj[row.fieldName][0]
                this.sForm[`${row.fieldName}_end`] = this.datetimerangeObj[row.fieldName][1]
                delete this.sForm[`${row.fieldName}`]
              } else {
                //存在返回true
                if (`${row.fieldName}_begin` in this.sForm) delete this.sForm[`${row.fieldName}_begin`]
                if (`${row.fieldName}_end` in this.sForm) delete this.sForm[`${row.fieldName}_end`]
						  }
            })
            console.log(this.sForm)
            self.$emit('saveFn', this.sForm)
          }
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .hotlineCusname{
    position: absolute;
    right: 40px;
    z-index: 9;
  }
  .fileList{
    margin-bottom: -5px;
    li{
      height: 25px;
      line-height: 25px;
      font-size: 12px;
      color: #000;
      &:hover .fileDel{
        display: inline-block;
      }
    }
    .fileIcon{
      color: #409EFF;
      margin-right: 5px;
    }
    .fileDel{
      display: none;
      margin-left: 5px;
      color: red;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .searchForm{
    padding: 10px 20px 0 20px;
  }
  .label-list{
    position: relative;
    overflow: hidden;
    .labelItem{
      float: left;
      border-radius: 6px;
      padding: 3px 8px;
      margin: 5px 8px 0 0;
      background: #41C663;
      color: #fff;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
    }
    .labelItem i{
      margin-left: 8px;
      cursor: pointer;
    }
  }
</style>
<style lang="scss">
  .formData{
    .detInfoList{
      .el-table td{
        padding: 10px 0 0 0 !important;
        &:nth-child(2) .cell{
          margin-top: -15px;
        }
      }
      .el-form-item{
        margin-bottom: 20px !important;
      }
    }
    .el-input-group__append{
      background-color: unset;
      padding: 0 15px;
    }
  }
  .cusLabDialog .el-dialog{
    margin-top: 10vh !important;
    height: 80% !important;
  }
  .cusLabDialog .el-dialog__body{
    height: calc(100% - 85px) !important;
  }
  .addData{
    .el-input-group__append{
      color: #409EFF;
    }
  }
</style>


// WEBPACK FOOTER //
// FormData.vue?6fb9975e